import styles from './Features.module.scss';
import Icon from '@/components/Icon';
import { ButtonType } from '@/components/Button/Button';
import { Link } from '@/i18n/navigation';
import Text from '@/components/Text/Text';

interface IFeatures {
  title: string,
  subtitle: string,
  cards: {
    id: number,
    title: string,
    description: string,
    button: {
      id: number;
      title: string;
      type: ButtonType;
      link: string;
    },
  }[]
}

const Features = ({ data }: { data: IFeatures }) => (
  <section className={styles.features}>
    <div className={styles.textContent}>
      <p className={styles.tagline}>{data.subtitle}</p>
      <Text tag='h2'>
        {data.title}
      </Text>
    </div>
    <ul className={styles.featuresList}>
      {data.cards.map((card) => (
        <li key={card.id}>
          <Link
            href={card.button.link || ''}
            className={styles.featuresCard}
          >
            <div className={styles.featuresCardContent}>
              <h4>{card.title}</h4>
              <p>{card.description}</p>
            </div>
            <div className={styles.discoverLink}>
              {card.button.title}
              <Icon
                name='arrow_forward'
              />
            </div>
          </Link>
        </li>
      ))}
    </ul>

  </section>
);

export default Features;
